import errorHandler from './ErrorHandler';
import Cookies from 'universal-cookie';
import {Linking, Platform} from 'react-native';
import userPref, {
  getCookiesValue,
  saveCookies,
} from '../HelperClasses/UserPrefrences';
import AppConstants from '../Constants/AppConstants';
import {ProjectTypeModel} from '../Models/ProjectTypeModel';
import {logout} from '../HelperClasses/SingletonClass';
import {captureNetworkFailure} from '../Monitoring/sentry';
var CryptoJS = require('crypto-js');
const cookies = new Cookies();
const APPURL = require('../Constants/URLConstants');
const APPConstants = require('../Constants/AppConstants');
const to = require('await-to-js').default;
let constantBBR = 'lkv294e1f1ac6j5a361b4516c5elkczjz';

const readJsonResponse = async response => {
  const body = await response.text();
  if (!body.trim()) {
    return {
      status: false,
      _monitoring: {malformed: true},
      error: {
        code: response.status,
        message: `Tradly returned an empty response (${response.status})`,
      },
    };
  }

  try {
    return JSON.parse(body);
  } catch (error) {
    return {
      status: false,
      _monitoring: {malformed: true},
      error: {
        code: response.status,
        message: `Tradly returned invalid JSON (${response.status})`,
      },
    };
  }
};

const TENANT_ADMIN_PATHS = [
  // Tenant configuration is used by admin settings pages (including the
  // WhatsApp connector). The configs API resolves the tenant from these
  // request headers, so it must use the same authenticated tenant context as
  // the other admin endpoints.
  APPURL.URLPaths.config,
  APPURL.URLPaths.config_list_group,
  APPURL.URLPaths.whatsappEmbeddedSignupConfig,
  APPURL.URLPaths.whatsappEmbeddedSignupExchange,
  APPURL.URLPaths.whatsappTemplateCatalog,
  APPURL.URLPaths.whatsappTemplates,
  APPURL.URLPaths.whatsappTemplateSubmit,
  APPURL.URLPaths.configsTranslations,
  APPURL.URLPaths.usageHistory,
  APPURL.URLPaths.mediaUsageSummary,
  APPURL.URLPaths.usageEvents,
  APPURL.URLPaths.automationRules,
  APPURL.URLPaths.purchaseOrders,
  APPURL.URLPaths.inventoryLocations,
  APPURL.URLPaths.hrDepartments,
  APPURL.URLPaths.hrJobProfiles,
  APPURL.URLPaths.hrPayGrades,
  APPURL.URLPaths.hrStaff,
  APPURL.URLPaths.hrShifts,
  APPURL.URLPaths.hrAttendance,
  APPURL.URLPaths.hrLeavePolicies,
  APPURL.URLPaths.hrLeaveBalances,
  APPURL.URLPaths.hrLeaveRequests,
  APPURL.URLPaths.hrPayrollRuns,
  APPURL.URLPaths.hrExpenseCategories,
  APPURL.URLPaths.hrExpenseClaims,
  APPURL.URLPaths.orderCashRefund,
  'v1/reward-programs',
  'v1/reward-programs/attribution-conversions',
];

export const isTenantAdminPath = path =>
  TENANT_ADMIN_PATHS.some(
    prefix =>
      path === prefix ||
      path.startsWith(`${prefix}/`) ||
      path.startsWith(`${prefix}?`),
  );

const isSkuaPath = path => {
  const normalizedPath = String(path || '').replace(/^\/+/, '');
  return normalizedPath === 'skua' || normalizedPath.startsWith('skua/');
};

export const tenantAdminHeaders = () => {
  // The bearer JWT identifies the authenticated admin. The API rejects a
  // client-supplied `admin` header, so only send tenant/user context here.
  const headers = {};
  if (AppConstants.tenantName) headers['tenant_id'] = `${AppConstants.tenantName}`;
  if (AppConstants.userId) headers['user_id'] = `${AppConstants.userId}`;
  return headers;
};

//j20294e1f1ac6c12361bs4516c5e155d0 login
class NetworkManager {
  getSessionCookie(suffix) {
    const configuredEnvironment = APPConstants.cookieEnvironment;
    const environments = [configuredEnvironment];

    // Local main-app builds have used both ck_p_* and ck_d_* over time.
    // Accept either namespace during local development so a valid session is
    // not mistaken for an expired session after switching local runtimes.
    if (APPConstants.isDevelopment) {
      ['p', 'd'].forEach(environment => {
        if (!environments.includes(environment)) environments.push(environment);
      });
    }

    for (const environment of environments) {
      const value = cookies.get(`ck_${environment}_${suffix}`);
      if (value !== undefined && value !== null && value !== '') return value;
    }

    return undefined;
  }

  getAuthKey() {
    return this.getSessionCookie('a');
  }
  getRefreshKey() {
    return this.getSessionCookie('r');
  }
  networkCall = async (
    path,
    method,
    param,
    token,
    auth,
    lang,
    onBoardingSanbox,
    user_auth_key,
    options,
  ) => {
    var agent = 3;
    if (Platform.OS == 'ios') {
      agent = 2;
    } else if (Platform.OS == 'android') {
      agent = 1;
    }
    var BaseURL = APPURL.URLPaths.BaseURL;
    if (!APPConstants.isDevelopment) {
      BaseURL =
        getCookiesValue(AppConstants.tradlyEVN) == 'sandbox'
          ? APPURL.URLPaths.sandboxBaseURL
          : APPURL.URLPaths.productionBaseURL;
    }

    var url = BaseURL + path;
    var bearerAuth = APPConstants.BearerAuthorization;
    // Skua services have their own host. Keep this routing explicit so a
    // sandbox/onboarding base URL cannot accidentally send Skua requests to
    // api.tradly.app.
    const existSkua = isSkuaPath(path);

    // if (path == APPURL.URLPaths.clients || path == APPURL.URLPaths.developerAPIKey || path == APPURL.URLPaths.createTenant || path == APPURL.URLPaths.skuaUser) {
    if (existSkua) {
      BaseURL = APPURL.URLPaths.skuaURL;
      url = BaseURL + path;
      if (path == APPURL.URLPaths.developerAPIKey) {
        url = BaseURL + `${path}${token}`;
      }
      bearerAuth = APPConstants.BearerForTantantsAndUserDetail;
    }
    if (!existSkua && url.includes(AppConstants.onBoardingKeys)) {
      if (!APPConstants.isDevelopment) {
        BaseURL = APPURL.URLPaths.productionBaseURL;
        url = BaseURL + path;
      }
    }
    if (!APPConstants.isDevelopment) {
      if (onBoardingSanbox && !existSkua) {
        BaseURL = APPURL.URLPaths.sandboxBaseURL;
        url = BaseURL + path;
      }
    }
    var authKey = user_auth_key ?? this.getAuthKey();

    let err, response;

    var headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-agent': 1,
      'x-tradly-agent': agent,
      'x-auth-key': authKey,
    };
    // Optional language headers must be omitted when callers pass the
    // legacy empty-string placeholder. Express-validator treats an empty
    // header as present-but-invalid, which makes otherwise valid requests
    // such as GET /v1/configs?key_group=whatsapp fail with 422.
    if (lang !== undefined && lang !== null && lang !== '') {
      headers['x-language'] = lang;
    }
    if (bearerAuth) {
      headers['Authorization'] = 'Bearer ' + bearerAuth;
    }

    // Tenant-scoped operations need the tenant/user context on the shared
    // client; the bearer JWT remains the only admin authentication signal.
    if (isTenantAdminPath(path)) {
      Object.assign(headers, tenantAdminHeaders());
    }
    if (options?.headers) {
      Object.assign(headers, options.headers);
    }

    [err, response] = await to(
      fetch(url, {
        method: method,
        dataType: 'json',
        headers: headers,
        body: param == '' ? null : param,
      }),
    );
    if (err) {
      captureNetworkFailure({
        error: err,
        path,
        method,
        service: existSkua ? 'skua' : 'api',
      });
      let error = err;
      return error;
    } else {
      const json = await readJsonResponse(response);
      if (json['status'] == true) {
        return json;
      } else {
        if (typeof json['error'] === 'string') {
          captureNetworkFailure({
            error: new Error(json['error_description'] || json['error']),
            path,
            method,
            status: response.status,
            service: existSkua ? 'skua' : 'api',
            shouldCapture: json._monitoring?.malformed === true || response.status >= 500,
          });
          // Some services return {error: 'CODE', error_description}; keep it so
          // the page can show the reason
          return json;
        }
        if (json['error']) {
          const errorCode = json['error']['code'];
          captureNetworkFailure({
            error: new Error(json['error']['message'] || String(errorCode || 'API request failed')),
            path,
            method,
            status: response.status,
            service: existSkua ? 'skua' : 'api',
            shouldCapture:
              json._monitoring?.malformed === true ||
              response.status >= 500 ||
              (typeof errorCode === 'number' && errorCode >= 500),
          });
          // Preserve feature-entitlement errors so pages can render the
          // correct upgrade state instead of treating a 403 as a generic
          // network failure.
          if (json['error']['code'] === 'API_ACCESS_REQUIRED') {
            return json;
          }
          let error = errorHandler.errorHandle(
            json['error']['code'],
            json['error']['message'],
          );
          if (json['error']['code'] == 401 && !options?.skipLogout) {
            // Linking.openURL(APPConstants.APPROOT)
            logout();
            return error;
          }
          return error;
        } else {
          return json ?? 'Failed';
        }
      }
    }
  };
  refreshKeyCall = async (path, method, param, token, auth) => {
    var BaseURL = APPURL.URLPaths.BaseURL;
    let url = BaseURL + APPURL.URLPaths.refreshToken;
    var refreshKey = this.getRefreshKey();
    let err, response;
    [err, response] = await to(
      fetch(url, {
        method: 'GET',
        dataType: 'json',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Refresh-Key': refreshKey,
          'x-agent': 1,
        },
      }),
    );
    if (err) {
      console.log('response error', err);
      return err;
    } else {
      const json = await readJsonResponse(response);
      if (json['error']) {
        if (json['error']['code'] == 401) {
          let error = errorHandler.errorHandle(
            json['error']['code'],
            json['error']['message'],
          );
          // if(AppConstants.projectType == ProjectTypeModel.delivery){
          //   let link = APPConstants.deliveryRootURL.replace('superadmin', AppConstants.appMainURL)
          //   Linking.openURL(link)
          // } else{
          //   let link = APPConstants.marketPlaceRootURL.replace('superadmin', AppConstants.appMainURL)
          //   Linking.openURL(link)
          // }
          // Linking.openURL(APPConstants.APPROOT)
          logout();

          return error;
        }
      } else {
        const auth_key = json['data']['user']['key']['auth_key'];
        const refresh_key = json['data']['user']['key']['refresh_key'];
        // Save under the names getSessionCookie reads, and keep the refresh key for its
        // 30-day lifetime so a returning admin is not logged out after a day away.
        const cookieEnv = APPConstants.cookieEnvironment;
        saveCookies(`ck_${cookieEnv}_a`, auth_key);
        saveCookies(`ck_${cookieEnv}_r`, refresh_key, 30 * 86400);
        return this.networkCall(path, method, param, token, auth_key);
      }
    }
  };
  async uploadFileWithSignedURL(signed_url, mime, blob_body) {
    let err, response;
    [err, response] = await to(
      fetch(signed_url, {
        method: 'put',
        headers: {'Content-Type': mime},
        body: blob_body,
      }),
    );
    if (err) {
      return false;
    } else {
      return true;
    }
  }
}

const network = new NetworkManager();
export default network;
